import React, { useState, useEffect, useRef } from "react";
import { BiRightArrowAlt } from "react-icons/bi";
import "./SubscriptionPrompt.css";

function SubscriptionPrompt() {
  const [showPrompt, setShowPrompt] = useState(false);
  const [showCookieConsent, setShowCookieConsent] = useState(false);
  const [cookieConsent, setCookieConsent] = useState(null);
  const [animateSubscriptionOut, setAnimateSubscriptionOut] = useState(false);
  const [animateSubscriptionRight, setAnimateSubscriptionRight] =
    useState(false);
  const [animateCookieConsentOut, setAnimateCookieConsentOut] = useState(false);
  const [email, setEmail] = useState("");
  const scrollInitiated = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!scrollInitiated.current && window.scrollY > 0) {
        scrollInitiated.current = true; // Mark that scroll has been handled
        setTimeout(() => {
          setShowPrompt(true);
          setShowCookieConsent(true);
        }, 5000); // 2 seconds delay
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [cookieConsent]);

  const handleClose = () => {
    setAnimateSubscriptionOut(true);
    setTimeout(() => setShowPrompt(false), 500); // Delay to match animation duration
  };

  const handleAcceptCookies = () => {
    setAnimateCookieConsentOut(true);
    setTimeout(() => setCookieConsent(true), 500);
  };

  const handleDeclineCookies = () => {
    setAnimateCookieConsentOut(true);
    setTimeout(() => setCookieConsent(false), 500);
  };

  const handleEmail = () => {
    setAnimateSubscriptionRight(true);
    setTimeout(() => setShowPrompt(false), 500); // Delay to match animation duration
  };

  return (
    <div>
      <div
        className={`subscription-prompt
         `}
      >
        {showPrompt && (
          <div
            className={`${animateSubscriptionOut ? "fade-out-down" : ""} ${
              animateSubscriptionRight ? "fade-out-right" : ""
            }`}
          >
            <button className="close-btn" onClick={handleClose}>
              ×
            </button>
            <div
              className={`subscription-content ${
                animateSubscriptionOut ? "fade-out-down" : ""
              } 
            ${animateSubscriptionRight ? "fade-out-right" : ""}`}
            >
              <p>
                Be the first to know <br /> Conceito Verde's next steps
              </p>
              <div className="email-input">
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  placeholder="Email Address"
                />
                <button className="email-btn" onClick={handleEmail}>
                  <BiRightArrowAlt />
                </button>
              </div>
            </div>
          </div>
        )}
        {showPrompt && cookieConsent === null && (
          <div className="line-spacer"></div>
        )}
        {showCookieConsent && cookieConsent === null && (
          <div
            className={`cookie-consent ${
              animateCookieConsentOut ? "fade-out-down" : ""
            }`}
          >
            <p>We use cookies to make things better</p>
            <button className="accept" onClick={handleAcceptCookies}>
              ● Accept
            </button>
            <button className="decline" onClick={handleDeclineCookies}>
              Decline
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default SubscriptionPrompt;
